export const languages = [
  {
    key: "ru",
    label: "Русский",
  },
  {
    key: "kz",
    label: "Казахский",
  },
  {
    key: "en",
    label: "Английский",
  },
  {
    key: "ar",
    label: "Арабский",
  },
];
